export default "__VITE_ASSET__SWN_mrRE__"